import React from 'react';

import { SVGPropsType } from 'src/types';

function EyeClose(props: SVGPropsType) {
    const { fill, onClick, style, className } = props;

    return (
        <svg
            width="12"
            height="13"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.42647 5.5001C6.89444 4.96806 6.03183 4.96806 5.49979 5.5001C4.96775 6.03214 4.96775 6.89475 5.49979 7.42678L24.573 26.5C25.105 27.032 25.9676 27.032 26.4997 26.5C27.0317 25.9679 27.0317 25.1053 26.4997 24.5733L24.4926 22.5663C26.5873 20.8942 28.178 18.6173 29 16C27.264 10.4727 22.1002 6.46344 16 6.46344C13.7881 6.46344 11.6993 6.99057 9.85242 7.92605L7.42647 5.5001ZM13.2316 11.3052L15.294 13.3677C15.5192 13.3074 15.7559 13.2753 16.0001 13.2753C17.5049 13.2753 18.7248 14.4952 18.7248 16C18.7248 16.2442 18.6927 16.4809 18.6324 16.7061L20.6949 18.7685C21.1744 17.9572 21.4495 17.0107 21.4495 16C21.4495 12.9904 19.0097 10.5506 16.0001 10.5506C14.9894 10.5506 14.0429 10.8257 13.2316 11.3052Z"
                fill={fill}
            />
            <path
                d="M19.3431 25.1234L15.6587 21.439C12.9209 21.2698 10.7303 19.0792 10.5611 16.3414L5.55705 11.3374C4.42044 12.6925 3.54271 14.2721 3 16.0001C4.73603 21.5273 9.8998 25.5366 16 25.5366C17.1534 25.5366 18.2734 25.3933 19.3431 25.1234Z"
                fill={fill}
            />
        </svg>
    );
}

export default EyeClose;
